export const translations = {
  es: {
    // Header
    header: {
      aboutBtn: 'Acerca de',
      experienceBtn: 'Experiencia',
      projectsBtn: 'Proyectos',
      contactBtn: 'Contacto',
      downloadCV: 'Descargar CV'
    },

    // Hero
    hero: {
      greeting: 'Hola soy Jereminth 👋',
      location: 'Cali, Colombia',
      available: 'Disponible para nuevos proyectos',
      description: 'Soy un ingeniero apasionado y me fascina la idea de crear soluciones, especializado en desarrollo full stack con (Python/React) integrando inteligencia artificial. Me entusiasma dar vida a los aspectos técnicos y visuales de los productos digitales y materializar las ideas.'
    },

    // About
    about: {
      tag: 'Acerca de mi',
      title: '¿Tienes curiosidad por mí?',
      paragraph1: 'Soy un ingeniero apasionado y me fascina la idea de crear soluciones, especializado en desarrollo full stack con (Python/React) integrando inteligencia artificial. Me entusiasma dar vida a los aspectos técnicos y visuales de los productos digitales y materializar las ideas.',
      paragraph2: 'Comencé mi trayectoria como ingeniero de soluciones en 2023 y, desde entonces, he seguido creciendo y evolucionando como desarrollador, software embebido, biomédico, asumiendo nuevos retos y aprendiendo las últimas tecnologías entrando al mundo de la IA. Ahora, con poco más de 22 años, 3 años después de empezar mi carrera, estoy creando aplicaciones relacionadas con la medicina en vanguardia con tecnologías modernas como Next.js, python, Supabase, OpenAI, AWS y muchas más.',
      paragraph3: 'Soy un pensador muy progresista y disfruto trabajando en productos de principio a fin, desde la ideación hasta el desarrollo.',
      paragraph4: 'Cuando no estoy en modo ingeniero, me puedes encontrar en eventos de creación de startups en mi tiempo libre.',
      paragraph5: 'Por último, algunas cosas rápidas sobre mí.',
      checklist1: 'Ingeniero biomédico',
      checklist2: 'Ingeniero de software',
      checklist3: 'Emprendedor',
      checklist4: 'Freelancer tiempo completo',
      closingText: 'Por último, estoy disponible para trabajos freelance, así que no dudes en contactarme y saludarme. Promeso que no muerdo 😉'
    },

    // Skills
    skills: {
      tag: 'Habilidades',
      subtitle: 'Las habilidades, herramientas y tecnologías en las que soy realmente bueno:'
    },

    // Experience
    experience: {
      tag: 'Experiencia',
      subtitle: 'Aquí hay un resumen de mis experiencias más recientes:',
      viewAll: 'Ver todas'
    },

    experiencePage: {
      tag: 'Toda mi Experiencia',
      title: 'Trayectoria Profesional Completa',
      description: 'Explora toda mi experiencia profesional en ingeniería biomédica, desarrollo de software y sistemas embebidos.'
    },

    // Projects
    projects: {
      tag: 'Proyectos',
      subtitle: 'Algunos de los proyectos notables que he construido:',
      viewAll: 'Ver todos'
    },

    projectsPage: {
      tag: 'Todos los Proyectos',
      title: 'Portafolio Completo',
      description: 'Explora todos los proyectos en los que he trabajado, desde desarrollo web hasta soluciones de inteligencia artificial.'
    },

    // Contact
    contact: {
      tag: 'Contacto',
      subtitle: '¿Qué sigue? No dudes en contactarme si buscas un desarrollador o un ingeniero de soluciones.',
      findMe: '¡Encontrarme en estas plataformas!'
    },

    // Footer
    footer: {
      copyright: '2025 | Construye junto a Jereminth'
    },

    // Projects Data
    projectsData: {
      kibo: {
        title: 'Kibo',
        description: 'KIBO es una herramienta monitorización cardíaca que puede reconocer y clasificar varios tipos de arritmias de manera eficiente.'
      },
      sbsBiophotonics: {
        title: 'SBS Biophotonics',
        description: 'Biophotonics es un dispositivo espectrofotómetro portátil, automatizado e inalámbrico, equipado con inteligencia artificial para el análisis de muestras biológicas en tiempo real.'
      },
      adsprintAI: {
        title: 'Adsprint AI',
        description: 'En AdsprintAI combinamos tecnología de inteligencia artificial con el poder de la cultura latina para ayudarte a crear anuncios tipo UGC de forma rápida, efectiva y personalizada.'
      }
    },

    // Experience Data
    experienceData: {
      pujPCB: {
        position: 'Ingeniero de PCB',
        company: 'PUJ Cali',
        item1: 'Realizar el diseño hardware para la obtención de señales de EMG.',
        item2: 'Documentar el proceso de diseño teniendo presente la justificación de la selección de los materiales y circuito elaborado.',
        item3: 'Integrar el sistema Hardware con el Software.'
      },
      upworkEmbedded: {
        position: 'Ingeniero de Sistemas Embebidos',
        company: 'Upwork',
        item1: 'Creación de hardware de un robot uniciclo.',
        item2: 'Programación en C para el microcontrolador del robot.',
        item3: 'Diseño de app movil para el control del robot.',
        item4: 'Desarrollo de la app movil para el control del robot.'
      },
      pujSoftware: {
        position: 'Ingeniero de software',
        company: 'PUJ Cali',
        item1: 'Estructurar y preparar datos de acuerdo con la recolección de información de proceso de auditoría de dengue.',
        item2: 'Desarrollar modelos de machine learning para la predicción de adherencia a la guia de atención de paciente con dengue.',
        item3: 'Usar algoritmos de PLN para el análisis de textos en las notas de evolución clínica de pacientes con dengue.'
      },
      pujElectronics: {
        position: 'Ingeniero electrónico de productos',
        company: 'PUJ Cali',
        item1: 'Diseñar y desarrollar el hardware de un dispositivo portátil para la medición de absorbancia.',
        item2: 'Programar el microcontrolador para la adquisición y procesamiento de datos.',
        item3: 'Diseño de planos de la tecnología para su fabricación.',
        item4: 'Proceso de patentacion y propiedad de la tecnología.'
      }
    }
  },

  en: {
    // Header
    header: {
      aboutBtn: 'About',
      experienceBtn: 'Experience',
      projectsBtn: 'Projects',
      contactBtn: 'Contact',
      downloadCV: 'Download CV'
    },

    // Hero
    hero: {
      greeting: 'Hello I\'m Jereminth 👋',
      location: 'Cali, Colombia',
      available: 'Available for new projects',
      description: 'I am a passionate engineer and I love the idea of creating solutions, specialized in full stack development with (Python/React) integrating artificial intelligence. I am excited to bring technical and visual aspects of digital products to life and materialize ideas.'
    },

    // About
    about: {
      tag: 'About me',
      title: 'Curious about me?',
      paragraph1: 'I am a passionate engineer and I love the idea of creating solutions, specialized in full stack development with (Python/React) integrating artificial intelligence. I am excited to bring technical and visual aspects of digital products to life and materialize ideas.',
      paragraph2: 'I started my career as a solutions engineer in 2023 and since then I have continued growing and evolving as a developer, embedded software, biomedical, taking on new challenges and learning the latest technologies entering the world of AI. Now, just over 22 years old, 3 years after starting my career, I am creating cutting-edge medical applications with modern technologies like Next.js, Python, Supabase, OpenAI, AWS and many more.',
      paragraph3: 'I am a very progressive thinker and I enjoy working on products from start to finish, from ideation to development.',
      paragraph4: 'When I\'m not in engineer mode, you can find me at startup creation events in my spare time.',
      paragraph5: 'Finally, some quick things about me.',
      checklist1: 'Biomedical Engineer',
      checklist2: 'Software Engineer',
      checklist3: 'Entrepreneur',
      checklist4: 'Full-time Freelancer',
      closingText: 'Finally, I am available for freelance work, so don\'t hesitate to contact me and say hi. I promise I don\'t bite 😉'
    },

    // Skills
    skills: {
      tag: 'Skills',
      subtitle: 'The skills, tools and technologies I\'m really good at:'
    },

    // Experience
    experience: {
      tag: 'Experience',
      subtitle: 'Here is a summary of my most recent experiences:',
      viewAll: 'View all'
    },

    experiencePage: {
      tag: 'All My Experience',
      title: 'Complete Professional Journey',
      description: 'Explore my complete professional experience in biomedical engineering, software development and embedded systems.'
    },

    // Projects
    projects: {
      tag: 'Projects',
      subtitle: 'Some of the notable projects I have built:',
      viewAll: 'View all'
    },

    projectsPage: {
      tag: 'All Projects',
      title: 'Complete Portfolio',
      description: 'Explore all the projects I have worked on, from web development to artificial intelligence solutions.'
    },

    // Contact
    contact: {
      tag: 'Contact',
      subtitle: 'What\'s next? Don\'t hesitate to contact me if you\'re looking for a developer or a solutions engineer.',
      findMe: 'Find me on these platforms!'
    },

    // Footer
    footer: {
      copyright: '2025 | Built with Jereminth'
    },

    // Projects Data
    projectsData: {
      kibo: {
        title: 'Kibo',
        description: 'KIBO is a cardiac monitoring tool that can recognize and classify various types of arrhythmias efficiently.'
      },
      sbsBiophotonics: {
        title: 'SBS Biophotonics',
        description: 'Biophotonics is a portable, automated and wireless spectrophotometer device equipped with artificial intelligence for real-time analysis of biological samples.'
      },
      adsprintAI: {
        title: 'Adsprint AI',
        description: 'At AdsprintAI we combine artificial intelligence technology with the power of Latin culture to help you create UGC-style ads quickly, effectively and personalized.'
      }
    },

    // Experience Data
    experienceData: {
      pujPCB: {
        position: 'PCB Engineer',
        company: 'PUJ Cali',
        item1: 'Perform hardware design to obtain EMG signals.',
        item2: 'Document the design process keeping in mind the justification of the selection of materials and circuits.',
        item3: 'Integrate the Hardware system with the Software.'
      },
      upworkEmbedded: {
        position: 'Embedded Systems Engineer',
        company: 'Upwork',
        item1: 'Hardware creation of a unicycle robot.',
        item2: 'C programming for the robot\'s microcontroller.',
        item3: 'Design of mobile app for robot control.',
        item4: 'Development of mobile app for robot control.'
      },
      pujSoftware: {
        position: 'Software Engineer',
        company: 'PUJ Cali',
        item1: 'Structure and prepare data according to the collection of information from the dengue audit process.',
        item2: 'Develop machine learning models for predicting adherence to the care guide for dengue patients.',
        item3: 'Use NLP algorithms for text analysis in clinical evolution notes of dengue patients.'
      },
      pujElectronics: {
        position: 'Product Electronics Engineer',
        company: 'PUJ Cali',
        item1: 'Design and develop the hardware of a portable device for absorbance measurement.',
        item2: 'Program the microcontroller for data acquisition and processing.',
        item3: 'Design of technology plans for its manufacture.',
        item4: 'Patent process and technology ownership.'
      }
    }
  }
};

